import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientBeneficiarySaveEmailMutation } from 'api/generated/graphql';
import { parseLegalClientBeneficiaryEntity, useError } from 'api/helpers';

interface Props {
  email: string;
  versionNumber: number;
  reason: string;
}

export const useLegalClientBeneficiarySaveEmail = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientBeneficiarySaveEmailMutation();

  const error = useError(apolloError);

  return {
    legalClientBeneficiary: data?.saveEmail
      ? parseLegalClientBeneficiaryEntity(data.saveEmail)
      : undefined,
    loading,
    error,
    saveEmail: useCallback(
      async (id: string, input: Props) => {
        const res = await handle({ variables: { id, input } });
        return res.data?.saveEmail
          ? parseLegalClientBeneficiaryEntity(res.data?.saveEmail)
          : undefined;
      },
      [handle]
    ),
  };
};
